import { render, staticRenderFns } from "./edit-claim-status.vue?vue&type=template&id=72f6784b&scoped=true&"
import script from "./edit-claim-status.vue?vue&type=script&lang=js&"
export * from "./edit-claim-status.vue?vue&type=script&lang=js&"
import style0 from "./edit-claim-status.vue?vue&type=style&index=0&id=72f6784b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f6784b",
  null
  
)

export default component.exports